<template>
  <div class="input-container">
    <label :for="names">
      <div class="label-container" :style="{background: pickedColor.hex || value}" @click="show = !show"></div>
    </label>
    <rum-label style="margin-bottom: 0;">{{ pickedColor.hex || value}}</rum-label>
    <chrome-picker
      v-on-click-outside="closeOnOutsideClick"
      style="position: absolute; z-index: 2; left: 20px; top: 200px;"
      v-if="show"
      :id="names"
      :style="value"
      v-model="pickedColor"
      @input="chooseColor">
    </chrome-picker>
  </div>
</template>

<script>
import { Chrome } from "vue-color";
import { mixin as onClickOutside } from "vue-on-click-outside";

export default {
  mixins: [onClickOutside],
  name: "RumieColorPicker",
  props: {
    names: String,
    value: String
  },
  components: {
    'chrome-picker': Chrome
  },
  data() {
    return {
      show: false,
      pickedColor: {
        hex: ""
      }
    }
  },
  methods: {
    closeOnOutsideClick() {
      this.show = false;
    },
    chooseColor(color) {
      this.$emit("input", color.hex);
    }
  }
};
</script>

<style scoped>
.input-container {
  width: fit-content;
  width: -moz-fit-content;
  margin-top: var(--spacing-4);
  display: flex;
  align-items: center;
  min-width: 150px;
  justify-content: space-around;
}

.input-container input {
  display: none;
}

.label-container {
  border: 1px solid #e9eaeb;
  border-radius: var(--border-radius-full);
  padding: 16px;
  width: 24px;
  height: 24px;
  cursor: pointer;
}
</style>